import { onMounted } from 'vue'

export function useSpeckleRedirectUrl() {
  const redirectUrl = ref<string | null>(null)

  onMounted(() => {
    const url = new URL(window.location.href)
    redirectUrl.value = `${url.origin}${url.pathname}`
  })

  return redirectUrl
}
